import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {cartRegister} from "../../services/cartRegister";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ErrorHandler from "../../components/error-handler/component";
import {imagesRegister} from "../../services/imagesRegister";
import {quotesRegister} from "../../services/quotesRegister";
import Information from "../../components/information/component";
import {videoRegister} from "../../services/videoRegister";
import {carouselRegister} from "../../services/carouselRegister";

class SignupBusiness extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            regions: [],
            region: null,
            company_name: "",
            search: ""
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/signup/business');
            ReactGA4.send({ hitType: "pageview", page: "/signup/business" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

        this._updateData();
    }

    _updateData() {
        try {
            let stored_data = cartRegister.get();
            if (stored_data.admin_image) {
                if (!stored_data.admin_image.data_url && !stored_data.admin_image.web_url) {
                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/image");
                }
            }
            if (stored_data.industry && (stored_data.image || stored_data.admin_image)) {
                this.setState({
                    company_name: stored_data.company_name,
                    region: stored_data.company_location
                }, () => {
                    if (this.state.region) {
                        this._selectRegion(this.state.region);
                    }
                    this._updateRegions(salesChannelRegister.get('market'));
                });
            } else {
                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/image");
            }
        } catch (error) {
            this.setState({error: true});
        }
    }

    _updateRegions(market) {
        this.setState({isLoading: true});
        dataRegister.regions(market, "").then((data) => {
            if (data) {
                //REMOVE ALL REGIONS THATS NOT SWEDEN (1) OR UAE (4940)
                let new_regions = [];
                for (let i = 0; i < data.regions.length; i++) {
                    if ((data.regions[i].level === 1 && data.regions[i].id !== 1 && data.regions[i].id !== 4940)
                        ||
                        (data.regions[i].level === 2 && data.regions[i].parent_id !== 1 && data.regions[i].parent_id !== 4940)
                    ) {

                    } else {
                        new_regions.push(data.regions[i]);
                    }
                }
                data.regions = new_regions;
                this.setState({regions: data.regions, isLoading: false});
            } else {
                this.setState({error: true});
            }
        }, (error) => {
            this.setState({error: true});
        });
    }

    _selectRegion(item) {
        this.setState({region: item, search: this._renderName(item)}, () => {
            try {
                let stored_data = cartRegister.get();
                if(stored_data.company_location.id !== item.id){
                    videoRegister.remove();
                    carouselRegister.remove();
                }
            }catch (e) {
                videoRegister.remove();
                carouselRegister.remove();
            }
            cartRegister.setCompanyLocation(item);
        });
    }

    _next() {
        if (this._renderCompanyName() && this.state.region) {
            try {
                let stored_data = cartRegister.get();
                if(stored_data.company_name !== this.state.company_name){
                    videoRegister.remove();
                    carouselRegister.remove();
                }
            }catch (e) {
                videoRegister.remove();
                carouselRegister.remove();
            }
            cartRegister.setCompanyName(this.state.company_name);
            //this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/theme");
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/ads");
        }
    }

    _back() {
        let view = JSON.parse(JSON.stringify(quotesRegister.getView()));
        if(view === "custom"){
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/quotes-custom");
        }else{
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get('name') + "/signup/quotes");
        }
    }

    _renderCompanyName(){
        try {
            let valid = false;
            let company_name = this.state.company_name.replace(/\s/g, '');
            if(company_name !== "" && company_name.length > 0 && company_name){
                valid = true;
            }
            return valid
        }catch (e) {
            return false
        }
    }

    _renderName(item) {
        try {
            if (salesChannelRegister.get('default_language') !== langRegister.lang()) {
                return item.internationalname;
            } else {
                return item.name
            }
        } catch (e) {
            return item.name
        }
    }

    _renderText(item) {
        return langRegister.get("signup-business", item);
    }

    render() {
        return (
            <div>
                <HeaderSignupOne view={"signup"} props={this.props}/>
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <div>
                                {this._renderText("item_1")}
                            </div>
                        </div>
                        <div className={Styles.optionsContainer}>
                            <input
                                maxLength={25}
                                value={this.state.company_name}
                                onChange={(event) => {
                                    String.prototype.allReplace = function (obj) {
                                        var retStr = this;
                                        for (var x in obj) {
                                            try {
                                                retStr = retStr.replace(new RegExp(x, 'g'), obj[x]);
                                            } catch (e) {
                                            }
                                        }
                                        return retStr;
                                    };
                                    let string = event.target.value.allReplace({
                                        '!': '',
                                        '&': '',
                                        ';': '',
                                        '_': '',
                                        '`': '',
                                        '+': '',
                                        '≈': '',
                                        '[': '',
                                        ']': '',
                                        '|': '',
                                        '§': '',
                                        '∞': '',
                                        '$': '',
                                        '£': '',
                                        '©': '',
                                        '#': '',
                                        '€': '',
                                        '%': '',
                                        '=': '',
                                        ')': '',
                                        '(': '',
                                        '/': '',
                                        '{': '',
                                        '}': ''
                                    });
                                    this.setState({company_name: string});
                                }}
                                placeholder={this._renderText("item_2")}
                                className={Styles.input}
                            />
                            <div className={Styles.inputContainer}>
                                <input onFocus={() => this.setState({dropdown: true}, () => {
                                })}
                                       onBlur={() => this.setState({dropdown: false})}
                                       value={this.state.search}
                                       onChange={(event) => this.setState({search: event.target.value}, () => {
                                           if (this.state.region) {
                                               try {
                                                   if (this._renderName(this.state.region) !== this.state.search) {
                                                       this.setState({region: null}, () => {
                                                           cartRegister.setCompanyLocation(null);
                                                       });
                                                   }
                                               } catch (e) {
                                               }
                                           }
                                       })}
                                       placeholder={this._renderText("item_3")}
                                       className={Styles.input}/>
                                {
                                    this.state.dropdown && this.state.regions.filter((item) => {
                                        return item.name.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                    }).length > 0 &&
                                    <div className={cx(Styles.inputDropdown, Styles.inputDropdownRegion)}>
                                        {
                                            this.state.regions.filter((item) => {
                                                return this._renderName(item).toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                            }).sort(function (a, b) {
                                                if (a.name < b.name) {
                                                    return -1;
                                                }
                                                if (a.name > b.name) {
                                                    return 1;
                                                }
                                                return 0;
                                            }).map((prop, key) => {
                                                return (
                                                    <div key={key}
                                                         onMouseDown={() => this._selectRegion(prop)}
                                                         className={Styles.inputDropdownItem}>
                                                        {this._renderName(prop)}
                                                        {prop.parent&&<span className={Styles.inputDropdownItemParent}>{prop.parent}</span>}
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                        <div onClick={() => this._next()} className={
                            cx(Styles.button,
                                {
                                    [Styles.buttonActive]: this.state.region && this._renderCompanyName(),
                                })
                        }>
                            {this._renderText("item_4")}
                        </div>
                        <div onClick={() => this._back()} className={Styles.backButton}>
                            {this._renderText("item_5")}
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'#41CBC7'} loading={true}/>
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props}/>
                    </div>
                }
                <div id={"bottom"} style={{width: "100%"}}/>
            </div>
        );
    }
}

export default SignupBusiness;


// WEBPACK FOOTER //
// ./src/pages/signup-business/component.js